export default __webpack_public_path__ + "static/media/walmart.bdbbb946.jpg";